import { useLocation } from "react-router";
import React, { useState, useEffect, useHistory, useRef } from "react";
import jsPDF from "jspdf";
import axios from "axios";
import jwt_decode from "jwt-decode";
import "../modal.css";
import Table from "./../Theme/Table.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../Spinner";
import { Button } from "react-bootstrap";
import { Checkbox, Modal } from "antd";
import Transactions from "../reports/Transactions";
import ReactToPrint from "react-to-print";
import ActionButtons from "./TransactionsActionButton.js";
import DeleteTripModal from "./DeleteTripModal.js";
const TransactionsList = () => {
  const location = useLocation();
  let [loading, setLoading] = useState(true);
  const [transactions, setTransactions] = useState([]);

  const getTransactions = async () => {
    const response = await axios
      .get("transactions/", {})
      .then((res) => {
        const transactionsWithMergedNames = res.data.map((transaction) => {
          const passengerName = `${transaction.passenger?.firstName} ${transaction.passenger?.lastName}`;
          const driverName = `${transaction.driver2?.firstName} ${transaction.driver2?.lastName}`;

          let newTrans = {
            ...transaction,
            passenger: { ...transaction.passenger, name: passengerName },
            driver: { ...transaction.driver2, name: driverName },
          };

          return newTrans;
        });
        setTransactions(transactionsWithMergedNames);
        setLoading(false);
        // notify()
      })
      .catch((err) => {
        console.log("========transactions======", err);
        notifyError();
      });
  };

  const notify = () =>
    toast.success("Vehicles list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  useEffect(() => {
    getTransactions();
  }, [location.key]);
  const columns = React.useMemo(
    () => [
      {
        Header: "Passenger",
        columns: [
          {
            Header: "Id",
            accessor: "id",
          },
          {
            Header: "First Name",
            accessor: "passenger.firstName",
          },
          {
            Header: "Last Name",
            accessor: "passenger.lastName",
          },
          {
            Header: "Phone Number",
            accessor: "passenger.phoneNumber",
          },
        ],
      },
      {
        Header: "Driver",
        columns: [
          {
            Header: "First Name",
            accessor: "driver.firstName",
          },
          {
            Header: "Last Name",
            accessor: "driver.lastName",
          },
          {
            Header: "Phone Number",
            accessor: "driver.phoneNumber",
          },
        ],
      },

      {
        Header: "Others",
        columns: [
          {
            Header: "Total Price in ETB",
            accessor: "actualPrice",
          },
          {
            Header: "Revenue in ETB",
            accessor: "revenue",
          },
          {
            Header: "Transaction Date",
            accessor: "createdAt",
          },
        ],
      },
      {
        Header: "Actions",
        columns: [
          {
            Header: "Delete",
            accessor: "actions",
            Cell: ({ row }) => (
              <DeleteTripModal 
                tripId={row.original.id} 
                onDeleteSuccess={getTransactions}
              />
            ),
          },
        ],
      },
    ],
    []
  );

  const columns_expo = React.useMemo(
    () =>
      [
        {
          columns: [
            {
              Header: "Id",
              accessor: "id",
            },
          ],
        },
        {
          Header: "Passenger",
          columns: [
            { Header: "Passenger Name", accessor: "passenger.name" },
            // { Header: "Last Name", accessor: "passenger.lastName" },
            { Header: "Passenger Phone", accessor: "passenger.phoneNumber" },
          ],
        },
        {
          Header: "Driver",
          columns: [
            { Header: "Driver Name", accessor: "driver.name" },
            // { Header: "Last Name", accessor: "driver.lastName" },
            { Header: "Driver Phone", accessor: "driver.phoneNumber" },
          ],
        },
        {
          Header: "Other",
          columns: [
            { Header: "Price", accessor: "actualPrice" },
            { Header: "Revenue", accessor: "revenue" },

            { Header: "Date", accessor: "createdAt" },
          ],
        },
      ].flatMap((group) => group.columns),
    []
  );
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const [selectedColumns, setSelectedColumns] = useState(
    columns_expo.map((column) => column.Header)
  );

  function handleExportClick(transactions, columns) {
    const doc = new jsPDF();

    const imgWidth = 100;
    const imgHeight = 100;
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const x = (pageWidth - imgWidth) / 2;
    const y = (pageHeight - imgHeight) / 2;

    doc.addImage("/eTaxi2.png", "PNG", x, y, imgWidth, imgHeight);

    const textX = x + imgWidth / 2;
    const textY = y - 10;

    doc.setFontSize(18);
    doc.text(
      `eTaxi transaction report for company: ${transactions[0]?.company?.companyName}`,
      textX,
      textY,
      {
        align: "center",
      }
    );

    doc.setFontSize(12);

    doc.addPage();

    doc.setFontSize(14);

    const tableData = transactions.map((transaction) =>
      columns.map((column) => {
        if (selectedColumns.includes(column.Header)) {
          const accessorKeys = column.accessor.split("."); // Split nested accessors
          let data = transaction;

          // Traverse through nested objects
          for (const key of accessorKeys) {
            if (data[key] !== undefined) {
              data = data[key];
            } else {
              data = ""; // Handle case where data is missing
              break;
            }
          }

          console.log(`Column: ${column.Header}, Data:`, data); // Debugging
          return data;
        }
      })
    );

    console.log("Table data:", tableData); // Debugging

    const tableWidth = "auto"; // Set the desired table width ('auto' or a specific number)
    const margin = { top: 15, right: 15, bottom: 15, left: 15 }; // Adjust margins as needed

    doc.autoTable({
      head: [
        columns.map((column) => {
          if (selectedColumns.includes(column.Header)) {
            return column.Header;
          }
        }),
      ],
      body: tableData,
      tableWidth,
      // margin,
    });

    // doc.autoTable({
    //   head: [columns.map((column) => column.Header)],
    //   body: tableData,
    // });

    doc.save("transaction_list.pdf");
  }

  const handleOkModal = () => {
    console.log("handleOkModal called");
    setIsModalVisible(false);
    handleExportClick(transactions, columns_expo);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // Inside your component
  function handleColumnToggle(columnHeader) {
    setSelectedColumns((prevSelectedColumns) => {
      if (prevSelectedColumns.includes(columnHeader)) {
        return prevSelectedColumns.filter((col) => col !== columnHeader);
      } else {
        return [...prevSelectedColumns, columnHeader];
      }
    });
  }

  const prRef = useRef(null);
  const [isPrintableComponentVisible, setIsPrintableComponentVisible] =
    useState(false);

  const handlePrintButtonClick = () => {
    setIsPrintableComponentVisible(true);
  };

  return (
    <div className="content-wrappers" style={{ marginTop: '-40px' }}>
    <div className="content-wrappers">
      <br />
      <br />
      <ToastContainer />

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <ActionButtons title="Transactions" showModal={showModal} />
                <Modal
                style={{marginTop: "60px"}} 
                    title="Select Columns to Export"
                    visible={isModalVisible}
                    onOk={handleOkModal}
                    onCancel={handleCancel}
                    footer={[
                      <Button key="cancel" onClick={handleCancel}>
                        Cancel
                      </Button>,
                      <Button
                        style={{ marginLeft: "10px" }}
                        key="ok"
                        type="primary"
                        onClick={handleOkModal}
                      >
                        OK
                      </Button>,
                    ]}
                  >
                    <div style={{ marginBottom: "20px" }}>
                      {columns_expo.map((column) => (
                        <div
                          key={column.Header}
                          style={{ marginBottom: "10px" }}
                        >
                          <Checkbox
                            checked={selectedColumns.includes(column.Header)}
                            onChange={() => handleColumnToggle(column.Header)}
                            style={{ marginRight: "10px", fontSize: "16px" }}
                          >
                            {column.Header}
                          </Checkbox>
                        </div>
                      ))}
                    </div>
                  </Modal>
                <div className="card-body">
                  {loading && (
                    <div>
                      <Spinner />
                    </div>
                  )}
                  {!loading && <Table columns={columns} data={transactions} />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    </div>
  );
};

export default TransactionsList;
